import { render, staticRenderFns } from "./norwich.vue?vue&type=template&id=721796d8&"
import script from "./norwich.vue?vue&type=script&lang=js&"
export * from "./norwich.vue?vue&type=script&lang=js&"
import style0 from "./norwich.vue?vue&type=style&index=0&media=screen&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports